import { render, staticRenderFns } from "./formV.vue?vue&type=template&id=05d05cde&scoped=true"
import script from "./formV.vue?vue&type=script&lang=js"
export * from "./formV.vue?vue&type=script&lang=js"
import style0 from "./formV.vue?vue&type=style&index=0&id=05d05cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d05cde",
  null
  
)

export default component.exports